var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaughing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_136682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 16.9705 16.9705 21 12 21C7.03 21 3 16.9705 3 12C3 7.03 7.03 3 12 3C16.9705 3 21 7.03 21 12Z",
    fill: "url(#paint0_radial_1448_136682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30612 20.5 3.5 16.6943 3.5 12C3.5 7.30614 7.30614 3.5 12 3.5C16.6943 3.5 20.5 7.30612 20.5 12Z",
    stroke: "#F6C64E",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0002C10.1885 14.0002 8.9865 13.7892 7.5 13.5002C7.1605 13.4347 6.5 13.5002 6.5 14.5002C6.5 16.5002 8.7975 19.0002 12 19.0002C15.202 19.0002 17.5 16.5002 17.5 14.5002C17.5 13.5002 16.8395 13.4342 16.5 13.5002C15.0135 13.7892 13.8115 14.0002 12 14.0002Z",
    fill: "#7B481A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5C7.5 14.5 9 15 12 15C15 15 16.5 14.5 16.5 14.5C16.5 14.5 15.5 16.5 12 16.5C8.5 16.5 7.5 14.5 7.5 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 12.1C18.243 12.0575 17.3345 11.387 15.977 10.928C15.99 10.8705 16 10.8115 16 10.75C16 10.5655 15.9305 10.3985 15.8205 10.268C16.7215 10.008 17.4875 10 17.501 10C17.7765 9.999 18 9.775 17.9995 9.499C17.999 9.2235 17.776 9 17.5 9C17.3895 9 14.7745 9.019 13.1465 10.6465C13.0035 10.7895 12.9605 11.0045 13.038 11.1915C13.115 11.378 13.298 11.5 13.5 11.5C15.795 11.5 17.6815 12.886 17.7005 12.9005C17.7905 12.9675 17.8955 12.9995 17.9995 12.9995C18.152 12.9995 18.302 12.93 18.4005 12.7995C18.5655 12.578 18.5205 12.2655 18.3 12.1ZM10.8535 10.6465C9.22598 9.019 6.61048 9 6.49998 9C6.22398 9 6.00048 9.2235 6.00048 9.499C5.99998 9.775 6.22348 9.999 6.49948 10C6.51248 10 7.27848 10.008 8.17998 10.268C8.06947 10.3985 7.99998 10.5655 7.99998 10.75C7.99998 10.8115 8.00948 10.8705 8.02348 10.928C6.66548 11.387 5.75698 12.0575 5.69998 12.1C5.47898 12.2655 5.43448 12.579 5.59998 12.7995C5.69798 12.931 5.84848 13 6.00048 13C6.10448 13 6.20998 12.9675 6.29998 12.9C6.31848 12.886 8.19348 11.5 10.5 11.5C10.702 11.5 10.8845 11.378 10.962 11.1915C11.0395 11.0045 10.9965 10.7895 10.8535 10.6465Z",
    fill: "#7B481A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1448_136682",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC4D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_136682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaughing);
export default __webpack_public_path__ + "static/media/laughing.77edfbe0027ff5ec8d3bd405d27d3ab7.svg";
export { ForwardRef as ReactComponent };